import { themeColorsGQLFields } from './themeColors.fields.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const newThemesGQLFields = (fields) => `
  id
  name
  typography {
    key
    value
  }
  colors {
    ${themeColorsGQLFields('all')}
  }
`;
//# sourceMappingURL=newTheme.fields.js.map